import effects from 'app/effects/effects'
import { all } from 'bluebird'
import * as R from 'ramda'
import { lensSelectedData } from 'libs/PagingLens'
import { TYPE_VOUCHER } from 'app/constants/messageType'

const pickAllTranslated = R.pickAll(['title', 'body'])

const pickVoucherTranslated = R.pickAll([
  'title',
  'body',
  'description',
  'voucherTitle',
  'voucherDescription',
])

export const translateByAllPlaceLanguage = (content) =>
  effects.apis
    .getAllPlaceLanguage()
    .then(translateAll(translateByContentAndId(content)))

const translateAll = (translateById) =>
  R.compose(
    all,
    R.map((lang) => translateById(lang.id)),
    R.view(lensSelectedData),
  )
export const createTranslationPayload = (languageId) => (content) => ({
  languageId: languageId,
  ...(content.notiType === TYPE_VOUCHER
    ? pickVoucherTranslated(content)
    : pickAllTranslated(content)),
})

export const translateByContentAndId = (content) => (id) => {
  return effects.apis.translate(createTranslationPayload(id)(content))
}
